module.exports = __webpack_public_path__ + "img/leather.be5030ca.webp";